/**
 * @generated SignedSource<<087456610a218431138fb63b129de13c>>
 * @relayHash c5c55d8477c91eca1e2b7a7852a0ec55
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 645576f388085a2d52b1d6771a273f4c09f389918dccd26f9d84c7c602b44c43

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type AccessType = "EDIT" | "VIEW" | "%future added value";
export type GrantContentAccessInput = {
  accessType: AccessType;
  accountIdOrUsername: string;
  contentId: string;
};
export type GrantAccessDialogGrantContentAccessMutation$variables = {
  grantContentAccessInput: GrantContentAccessInput;
};
export type GrantAccessDialogGrantContentAccessMutation$data = {
  readonly grantContentAccess: {
    readonly success: boolean;
  } | null | undefined;
};
export type GrantAccessDialogGrantContentAccessMutation = {
  response: GrantAccessDialogGrantContentAccessMutation$data;
  variables: GrantAccessDialogGrantContentAccessMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "grantContentAccessInput"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "grantContentAccessInput",
        "variableName": "grantContentAccessInput"
      }
    ],
    "concreteType": "GrantContentAccessPayload",
    "kind": "LinkedField",
    "name": "grantContentAccess",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "success"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "GrantAccessDialogGrantContentAccessMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GrantAccessDialogGrantContentAccessMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c5c55d8477c91eca1e2b7a7852a0ec55",
    "id": "645576f388085a2d52b1d6771a273f4c09f389918dccd26f9d84c7c602b44c43",
    "metadata": {},
    "name": "GrantAccessDialogGrantContentAccessMutation",
    "operationKind": "mutation",
    "text": "mutation GrantAccessDialogGrantContentAccessMutation($grantContentAccessInput:GrantContentAccessInput!){grantContentAccess(grantContentAccessInput:$grantContentAccessInput){success}}"
  }
};
})();

(node as any).hash = "e9b5b9069ae06c36d554795608b91e64";

export default node;
